import { Locale, SubtitleTextColors, SubtitleTextSizes } from '../typings';

export const es_US: Locale = {
  name: 'es_US',
  translations: {
    General: {
      On: 'Activado',
      Off: 'Desactivado',
    },
    BottomControls: {
      PlayingOn: (device: string) => `Reproduciendo en ${device}`,
    },
    ContextMenuOverlay: {
      Version: (version: string) => `Version: ${version}`,
      PoweredByBeachbody: 'Con tecnología de Beachbody',
    },
    ErrorOverlay: {
      ErrorCode: (code: number) => `Error ${code}`,
      CannotBePlayed: 'No es posible reproducir este video.',
      PleaseTryAgain: 'Inténtalo de nuevo más tarde.',
    },
    LanguageOptions: {
      Subtitles: 'Subtítulos',
      SubtitleOptions: 'Opciones',
      Audio: 'Audio',
    },
    SubtitleOptions: {
      FontSize: 'Tamaño de letra',
      TextSizeOption: (textSize) => {
        switch (textSize) {
          case SubtitleTextSizes.Smallest:
            return 'Más pequeño';
          case SubtitleTextSizes.Small:
            return 'Pequeño';
          case SubtitleTextSizes.Normal:
            return 'Normal';
          case SubtitleTextSizes.Large:
            return 'Grande';
          case SubtitleTextSizes.Largest:
            return 'Más grande';
          default:
            return 'Normal';
        }
      },
      TextColorOption: (textColor) => {
        switch (textColor) {
          case SubtitleTextColors.White:
            return 'Blanco';
          case SubtitleTextColors.Gray:
            return 'Gris';
          case SubtitleTextColors.Black:
            return 'Negro';
          case SubtitleTextColors.Yellow:
            return 'Amarillo';
          case SubtitleTextColors.Orange:
            return 'Naranja';
          case SubtitleTextColors.Red:
            return 'Rojo';
          case SubtitleTextColors.Green:
            return 'Verde';
          case SubtitleTextColors.Cyan:
            return 'Cian';
          case SubtitleTextColors.Blue:
            return 'Azul';
          default:
            return 'Blanco';
        }
      },
      FontColor: 'Color de letra',
      BoldText: 'Texto en negrita',
    },
    ModifierIndicator: {
      Modifier: 'Modificador',
    },
    ResumeOverlay: {
      AboutToPlay: 'A punto de reproducir',
      ResumeVideo: 'Reanudar el video',
      StartOver: 'Comenzar de nuevo',
    },
  },
};
